import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import { useDashboardToast } from '@/composables/useDashboardToast'
import { useDeleteLinkedAccountModal } from '@/composables/useDeleteLinkedAccountModal'

/**
 * Shared actions for linked email accounts, uses existing Donor API:
 * POST /me/details (primary), DELETE /me/accounts/:id, POST /me/accounts (add).
 */
export function useEmailAccountActions() {
  const store = useStore()
  const { t } = useI18n()
  const { showToast } = useDashboardToast()
  const { openDeleteLinkedAccountModal } = useDeleteLinkedAccountModal()

  const setPrimaryEmail = async (emailAddress: string) => {
    const userDetails = store.state.donor?.userDetails
    const details = userDetails?.details ?? {}

    const response = await store.dispatch('postDonorInformation', {
      firstname: details.firstname,
      lastname: details.lastname,
      addressLine1: details.addressLine1,
      addressLine2: details.addressLine2,
      city: details.city,
      county: details.county,
      postcode: details.postcode,
      country: details.country,
      emailAddress,
    })

    if (response?.status >= 200 && response?.status < 300) {
      store.commit('SET_USER_EMAIL', emailAddress)
      store.commit('accounts/UPDATE_PRIMARY_EMAIL_ACCOUNT', emailAddress)
      showToast(t('Dashboard.Status.Emails.PrimarySetToast'))
      return true
    }

    showToast(t('Dashboard.Status.Emails.PrimarySetFailed'))
    return false
  }

  const promptDeleteEmail = (emailAddress: string) => {
    store.dispatch('accounts/setAccountToBeDeleted', emailAddress)
    openDeleteLinkedAccountModal()
  }

  return {
    setPrimaryEmail,
    promptDeleteEmail,
  }
}
